import styled from "styled-components"

import { ProfileCardProps, Social } from "./types";
import { CardTitle, CardParagraph, ProfileCardStack } from "./styled";

import { RoundedImage } from "@components/Image";
import { IconLink } from "@components/Links";

const CardImage = styled(RoundedImage)`
  width: 100%;
`;

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
`;

const SocialContainer = styled.div`
  display: flex;
  align-items: center;

  > a {
    margin: 0 4px;
  }
`;

const ProfileCard = ({
  imgUrl,
  title,
  socials,
  children,
}: ProfileCardProps) => (
  <ProfileCardStack spacing={2}>
    <CardImage src={imgUrl} />
    <HeaderRow>
      <CardTitle>{title}</CardTitle>
      <SocialContainer>
        {socials.map((social: Social) => (
          <IconLink key={social.url} href={social.url}>
            {social.icon}
          </IconLink>
        ))}
      </SocialContainer>
    </HeaderRow>
    <CardParagraph>{children}</CardParagraph>
  </ProfileCardStack>
);

export default ProfileCard;
